import React from "react";
import ReactDOM from "react-dom";
import "./MobileAppModal.scss";
import { useModalStore } from "@/store/useModalStore";

import phoneQr from "@assets/img/phone-qr.svg";
import qrImg from "@assets/img/qr.png";
import { useTranslation } from "react-i18next";

function MobileAppModal() {
  const { isOpen, type, closeModal } = useModalStore();
  const { t: tCommon } = useTranslation(["common"]);

  if (!isOpen || type !== "mobileApp") return null;

  return ReactDOM.createPortal(
    <div className="mobile-app-modal">
      <div className="mobile-app-modal__overlay" onClick={closeModal}></div>

      <div
        className="mobile-app-modal__content"
        role="dialog"
        aria-modal="true"
      >
        <div className="mobile-app-modal__card">
          <button className="mobile-app-modal__close" onClick={closeModal}>
            ✕
          </button>
          <div className="mobile-app-modal__left">
            <h3>{tCommon("titleMobileModal.title")}</h3>
            <div className="mobile-app-modal__wrap">
              <div className="mobile-app-modal__qr">
                <img src={qrImg} alt="QR для скачивания приложения" />
              </div>

              <p>{tCommon("descriptionMobileModal.title")}</p>
            </div>
          </div>
          <div className="mobile-app-modal__right">
            <img src={phoneQr} alt="Экран приложения" />
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}

export default MobileAppModal;
